export default __webpack_public_path__ + "static/media/security-icon3.820fd3ed.svg";